export default __webpack_public_path__ + "static/media/Miscellaneous.fc9554ed.jpg";